import { gql } from "apollo-boost";

export const modelInfoSchema = `
  modelID 
  name 
  modelType 
  modeler  {
    adminID 
    fullName
    avatarURL
    createdAt
    updatedAt
    broker {
      brokerID
      name
    }
  }
  universe 
  minPortValue 
  pctFlatCommission 
  pctProfitSharing 
  shortDesc 
  longDesc 
  videoURL 
  svgReturnUrl 
  signalType 
  signalTriggerType 
  signalTriggerParam 
  rebalanceType 
  rebalanceParam 
  createdAt 
  updatedAt 
  lastSignalDateTime 
  periodsModelReturn {
    period
    return
    snapDatetime
  }

`

//modelInfo ...
export const MODEL_INFO = gql`
    query modelInfo(
        $modelID: String!
    ) {
        modelInfo(
            modelID: $modelID
        ) {
            __typename
            ... on ModelInfo {
              ${modelInfoSchema}
            }
            ... on Error {
                code
                message
            }
        }
    }
`

//modelInfos ...
export const MODEL_INFOS = gql`
query modelInfos {
  modelInfos {
      __typename
      ... on ModelInfos {
          models {
            ${modelInfoSchema}
          }
      }
      ... on Error {
          code
          message
      }
  }
}
`


export const MODEL_RETURNS = gql`
query modelReturns($modelID: String!, $length: String!) {
  modelReturns(modelID: $modelID, length: $length) {
    __typename
    ... on ModelReturns {
      modelReturns {
        date
        pctReturn
      }
    }
    ... on Error {
      code
      message
    }
  }
}
`;

export const MODEL_SIGNALS = gql`
query modelSignals(
  $modelID: String!
) {
  modelSignals(modelID:$modelID) {
    __typename
    ... on  ModelSignals{
       modelSignals{
         symbolInfo{
          symbol
          companyNameTh
        }
        pctWeight
      }
      signalDateTime
    }
    ... on Error {
      code
      message
    }
  }
}
`;


export const MODEL_STAT = gql`
query modelStat(
  $modelID: String!
) {
  modelStat(modelID:$modelID) {
    __typename
    ... on ModelStat {
      modelID 
      startInitialBacktestDatetime 
      endInitialBacktestDatetime 
      lastBacktestDatetime
      cagr 
      pctWinPerTrade 
      std 
      pctMaximumDrawdown 
      pctAvgProfit 
      pctAvgLoss 
      sharpeRatio 
    }
    ... on Error {
      code
      message
    }
  }
}
`;


export const MODEL_MONTHLY_RETURNS = gql`
  query modelMonthlyReturns(
    $modelID: String!,
    $year: Int!
  ) {
    modelMonthlyReturns(modelID:$modelID,year:$year) {
      __typename
      ... on ModelMonthlyReturns {
        modelMonthlyReturns {
          month
          pctReturn
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;